import React, { useEffect } from "react";
import { useWizard } from "store/wizard";
import { Loading } from "components/form";
import ReactHtmlParser from "react-html-parser";
import { toJalali } from "lib/helpers";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "store/auth";
import { handleSuccessMessages } from "store/auth";
import { handleDangerMessages } from "store/auth";

const Summery = (props) => {
  const navigate = useNavigate();
  const {
    product: {
      type,
      countries,
      detail,
      product_categories,
      country_filter_type,
      product_detail,
      prices,
      product_owners,
      product_active_times,
    },
    seasons,
    load,
    dispatch,
    previous,
  } = useWizard();
  const wizard = useWizard();

  const TYPES = {
    Movie: "فیلم",
    Serie: "سریال",
    Music: "موزیک",
    SerieEpisode: "قسمتی از سریال",
    Screening: "اکران",
    Physical: "فیزیکی",
    Download: "دانلودی",
    HASHURE_STRIMING: "vod",
    // DORDIS: "دوردیس",
    // VOD: "وی او دی",
    All: "همه",
    Only: "فقط",
    Except: "به جزء",
    fa: "فارسی",
    en: "انگلیسی",
  };
  if (load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  const changeProductStatus = async (
    productId,
    currentStatus,
    dispatch,
    changeStatus
  ) => {
    let response;
    try {
      const newStatus = currentStatus === "Publish" ? "Draft" : "Publish";

      response = await axiosInstance.post("/panel/product-status/", {
        product_id: productId,
        previous_status: currentStatus,
        new_status: newStatus,
      });

      handleSuccessMessages("تغییر وضعیت محصول با موفقیت ثبت شد.");

      // dispatch(changeStatus(newStatus));
    } catch (error) {
      console.log("response: ", response);

      // بررسی و نمایش ارور
      if (error.response) {
        const { status, data } = error.response;

        // وضعیت و پیام ارور را نمایش دهید
        console.error(`Error ${status}:`, data.message || "خطای نامشخص");

        // نمایش پیام مناسب به کاربر
        handleDangerMessages(data.message || "خطا در تغییر وضعیت محصول.");
      } else if (error.request) {
        // وقتی درخواست ارسال شده اما پاسخی دریافت نشده است
        console.error("No response received:", error.request);
        handleDangerMessages("خطا در برقراری ارتباط با سرور.");
      } else {
        // ارور دیگر (مانند خطاهای داخلی جاوااسکریپت)
        console.error("Error:", error.message);
        handleDangerMessages("خطای داخلی برنامه.");
      }
    }
  };

  const activeTimesType = {
    Activation: "نمایش در سایت",
    Screening: "اکران",
    TicketSelling: "بلیت فروشی",
  };
  return (
    <>
      <div className="font-medium text-base flex justify-between">
        <h2>پیش نمایش</h2>
        <div>
          <span>وضعیت محصول : </span>

          <button
            className={`btn btn-sm ${
              wizard.product && wizard.product.status == "Publish"
                ? "btn-success"
                : "btn-danger"
            }`}
            onClick={
              //() => wizard.dispatch(wizard.changeStatus())
              () => {
                changeProductStatus(
                  wizard.product.id,
                  wizard.product.status,
                  wizard.dispatch,
                  wizard.changeStatus
                );
              }
            }
          >
            {wizard.product && wizard.product.status == "Publish"
              ? "منتشر شده"
              : "پیش نویس"}
          </button>
        </div>
      </div>
      <hr className="my-2" />
      <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
        <div className="col-span-12 grid grid-cols-3">
          <div>
            <span>عنوان : </span>
            <span>{detail && detail.title}</span>
          </div>
          <div>
            <span>نوع محصول : </span>
            <span>{TYPES[type]}</span>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-2">
          <div>
            <span>ژانر ها : </span>
            <span>
              {detail &&
                detail.genres.length > 0 &&
                detail.genres.map((item) => item.name).join(" ، ")}
            </span>
          </div>
          <div>
            <span>دسته بندی ها : </span>
            <span>
              {product_categories.map((item) => item.name).join(" ، ")}
            </span>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-5">
          <div>
            <span> تاریخ انتشار(شمسی) : </span>
            <span>{detail && detail.release_date}</span>
          </div>

          <div>
            <span> کشور سازنده : </span>
            <span>{detail && detail.country && detail.country.fa_name}</span>
          </div>
          {wizard.type != "Serie" && (
            <div>
              <span> مدت زمان فیلم : </span>
              <span>{detail && detail.duration}</span>
            </div>
          )}
          <div>
            <span> امتیاز IMDB : </span>
            <span>{detail && detail.imdb_rate}</span>
          </div>

          <div>
            <span> محدودیت سنی: </span>
            <span>{detail && detail.age_restriction}</span>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-5">
          {wizard.type != "Serie" && (
            <>
              <div>
                <span> منبع سورس ویدئو : </span>
                <span>{detail && TYPES[detail.video_source_type]}</span>
              </div>
              <div>
                <span> آیدی سورس ویدئو : </span>
                <span>{detail && detail.video_source_id}</span>
              </div>
              <div>
                <span> زمان شروع تیتراژ : </span>
                <span>{detail && detail.starting_title_time}</span>
              </div>
              <div>
                <span> زمان پایان تیتراژ : </span>
                <span>{detail && detail.ending_title_time}</span>
              </div>
            </>
          )}
          <div>
            <span> فیلتر کشور : </span>
            <span>
              {country_filter_type == "All"
                ? TYPES[country_filter_type]
                : country_filter_type == "Only"
                ? TYPES[country_filter_type] +
                  " : " +
                  (countries &&
                    countries.length > 0 &&
                    countries.map((item) => item.fa_name).join(" ، "))
                : TYPES[country_filter_type] +
                  " : " +
                  (countries &&
                    countries.length > 0 &&
                    countries.map((item) => item.fa_name).join(" ، "))}
            </span>
          </div>
        </div>
        <div className="col-span-12">
          <div>
            <span> عوامل : </span>
            <span>
              {detail &&
                detail.casts.length > 0 &&
                detail.casts
                  .map(
                    (item) =>
                      item.cast.full_name +
                      "(" +
                      (item.activity_field && item.activity_field.name) +
                      ")"
                  )
                  .join(" ، ")}
            </span>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-2 gap-4">
          <div>
            <span>خلاصه فیلم :</span>
            <p className="text-justify rounded border-dashed border-2 p-1">
              {detail && ReactHtmlParser(detail.short_synopsis)}
            </p>
          </div>
          <div>
            <span>داستان فیلم :</span>
            <p className="text-justify rounded border-dashed border-2 p-1">
              {detail && ReactHtmlParser(detail.synopsis)}
            </p>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-3 gap-2">
          <div className="p-2">
            <p>تصویر پس زمینه</p>
            <div className="mt-2 flex justify-center">
              <img
                className="h-48"
                src={
                  product_detail &&
                  product_detail.background_media &&
                  product_detail.background_media.url
                }
                alt=""
              />
            </div>
          </div>

          <div className="p-2">
            <p>تصویر عمودی</p>
            <div className="mt-2 flex justify-center">
              <img
                className="h-48"
                src={
                  product_detail &&
                  product_detail.vertical_media &&
                  product_detail.vertical_media.url
                }
                alt=""
              />
            </div>
          </div>

          <div className="p-2">
            <p>تصویر افقی</p>
            <div className="mt-2 flex justify-center">
              <img
                className="h-48"
                src={
                  product_detail &&
                  product_detail.horizontal_media &&
                  product_detail.horizontal_media.url
                }
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-2 gap-4">
          <div className="border-dashed border-2 rounded p-2">
            <p>تریلر ها</p>
            <hr className="my-2" />
            <div className="grid grid-cols-5 gap-3">
              <h5>زبان</h5>
              <h5 className="col-span-4 text-center">لینک فایل</h5>
            </div>
            {product_detail &&
              product_detail.trailers.map((item) => (
                <>
                  <div className="grid grid-cols-5 gap-3">
                    <h5>{item.language == "fa" ? "فارسی" : "انگلیسی"}</h5>
                    <p className="col-span-4 text-center">{item.source}</p>
                  </div>
                </>
              ))}
          </div>
          {wizard.type == "Serie" && (
            <div className="border-dashed border-2 rounded p-2">
              <p>فصل ها</p>
              <hr className="my-2" />
              <div className="grid grid-cols-5 gap-3">
                <h5>عنوان</h5>
                <h5 className="col-span-4 text-center">خلاصه</h5>
              </div>
              {seasons &&
                seasons.map((item) => (
                  <>
                    <div className="grid grid-cols-5 gap-3">
                      <h5>{item.title}</h5>
                      <p className="col-span-4 text-center">{item.summary}</p>
                    </div>
                  </>
                ))}
            </div>
          )}
          {wizard.type != "Serie" && (
            <div className="border-dashed border-2 rounded p-2">
              <p>زیرنویس ها</p>
              <hr className="my-2" />
              <div className="grid grid-cols-5 gap-3">
                <h5>زبان</h5>
                <h5 className="col-span-2 text-center">برچسب</h5>
                <h5 className="col-span-2 text-center">لینک فایل</h5>
              </div>
              {product_detail &&
                product_detail.subtitles.map((item) => (
                  <div className="grid grid-cols-5 gap-3">
                    <h5>{item.language == "fa" ? "فارسی" : "انگلیسی"}</h5>
                    <p className="col-span-2 text-center">{item.label}</p>
                    <p className="col-span-2 text-center">{item.file_name}</p>
                  </div>
                ))}
            </div>
          )}
        </div>
        {wizard.type != "Serie" && (
          <div className="col-span-12 grid grid-cols-5 gap-4">
            <div className="text-center col-span-5 grid grid-cols-2 border-2 border-dashed rounded p-2">
              <p>نوع</p>
              <p>زبان</p>
              <p>بازه انتشار</p>
              <hr className="my-1 col-span-3" />
              {product_active_times &&
                product_active_times.length > 0 &&
                product_active_times.map((item) => (
                  <>
                    <p>{activeTimesType[item.type]}</p>
                    <p>{TYPES[item.language]}</p>
                    {item.for_ever ? (
                      <p>برای همیشه</p>
                    ) : (
                      <p>
                        <span>
                          {" "}
                          از{" "}
                          {toJalali(item.active_from, "hh:mm:ss jDD-jMM-jYYYY")}
                        </span>
                        <span>
                          {" "}
                          تا{" "}
                          {toJalali(item.active_to, "hh:mm:ss jDD-jMM-jYYYY")}
                        </span>
                      </p>
                    )}
                  </>
                ))}
            </div>
            <div className="text-center col-span-2 border-2 border-dashed rounded p-2">
              <p className="grid grid-cols-3 gap-4">
                <span className="col-span-2">قیمت ها</span>
                <span>وضعیت</span>
              </p>
              <hr className="my-1" />
              {prices.map((item) => (
                <div className="grid grid-cols-3 gap-4">
                  <p className="col-span-2">
                    <span>{item.amount}</span>
                    <span>{item.currency == "IRR" ? " تومان" : " دلار"}</span>
                  </p>
                  <p>{item.status ? "فعال" : "غیرفعال÷"}</p>
                </div>
              ))}
            </div>
            <div className="text-center col-span-3 border-2 border-dashed rounded p-2">
              <p>سهام دارارن</p>
              <hr className="my-1" />
              <div className="grid grid-cols-5">
                {product_owners.map((item) => (
                  <>
                    <p className="col-span-4">
                      {item.user && item.user.complete_name}
                    </p>
                    <p className="col-span-1">
                      {item.share_in_sales_prcent} درصد
                    </p>
                  </>
                ))}
              </div>
            </div>
          </div>
        )}
        <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
          <button
            className="btn btn-secondary w-24"
            type="button"
            onClick={() => {
              dispatch(previous());
            }}
          >
            قبلی
          </button>
          <button
            className="btn btn-primary w-24 mr-2"
            onClick={() => navigate(-1)}
          >
            خروج
          </button>
        </div>
      </div>
    </>
  );
};

export default Summery;
